import React from 'react';

interface PageHeaderProps {
  children: React.ReactNode;
  /**
   * Additional className to apply. Default padding is always applied.
   * Use this for margin-bottom, flex, or other layout classes.
   */
  className?: string;
  /**
   * Override the default top padding. If not provided, uses pt-12 sm:pt-6.
   */
  paddingTop?: string;
}

/**
 * PageHeader component that provides consistent top padding.
 * Layout already handles fixed nav clearance; this just adds breathing room.
 * Default padding: pt-12 sm:pt-6 (mobile: 3rem for bottom nav overlap, desktop: 1.5rem)
 */
const PageHeader: React.FC<PageHeaderProps> = ({ children, className = '', paddingTop = 'pt-12 sm:pt-6' }) => {
  const combinedClassName = `${paddingTop} ${className}`.trim();

  return (
    <div className={combinedClassName}>
      {children}
    </div>
  );
};

export default PageHeader;

